import { config } from 'src/core/config';

export function getPlatformUserAvatarUrl(
  partnerId: string | number | null | undefined,
  fileKey: string | null | undefined,
): string | undefined {
  if (!fileKey || partnerId === null || partnerId === undefined) {
    return undefined;
  }
  return `${config.s3PublicReadUrl}avatars/${partnerId}/${fileKey}`;
}

function resolvePublicReadFolder(): string {
  const url = config.s3PublicReadUrl as string | undefined;
  if (!url) {
    return 'public';
  }
  try {
    const segments = new URL(url).pathname.split('/').filter(Boolean);
    return segments[segments.length - 1] ?? 'public';
  } catch {
    return 'public';
  }
}

const PUBLIC_READ_FOLDER = resolvePublicReadFolder();

export function getPlatformUserAvatarStorageKey(
  partnerId: string | number | null | undefined,
  fileKey: string | null | undefined,
): string | undefined {
  if (!fileKey || partnerId === null || partnerId === undefined) {
    return undefined;
  }
  return `${PUBLIC_READ_FOLDER}/avatars/${partnerId}/${fileKey}`;
}
